import React from 'react'
import './CreateBenchmarkByTemplateUpload.css';
import * as FeatherIcon from 'react-feather';
import Button from 'react-bootstrap/Button';


function CreateBenchmarkByTemplateUpload() {
  return (
    <div className='create_benchmark_wrapper'>
      <div className='template_req_block'>
        <h5 className='template_head'>Template Requirements:</h5>
        <p className='template_para'>Include competitor names in first column/row • Clearly label dimensions and metrics • Use consistent data formats • Include header rows for identification</p>
      </div>
      <div className='sample_template_block'>
        <h5 className='sample_template_head'>Sample Templates:</h5>
        <div className='sample_subtemplate_block'>
          <div className='sample_template_tags'>
            <p className='sample_template_text'>Porter’s 5 Forces Template <FeatherIcon.Download className='download_icon'/></p>
          </div>
        </div>
      </div>
      <div className='upload_file_block'>
        <div className='file_block'>
            <FeatherIcon.File className='file_icon'/>
        </div>
        <div className='text_file_block'>
          <h5 className='text_file_head'>Drop files here or click to upload</h5>
          <p className='text_file_para'>Supported formats: CSV, Excel (.xlsx, .xls), JSON <br/> Maximum file size: 10MB</p>
          <div className="file-input">
            <input type="file" name="file-input" id="file-input" className="file-input__input"/>
            <label className="file-input__label" for="file-input">        
            <span className='upload_file'>File Upload</span></label>
           </div>
        </div>
      </div>

      <div className="document_upload_block">
        <div className='icon_text_left_block'>
          <div className='file_block'>
              <FeatherIcon.File className='file_icon'/>
          </div>
          <div className='successful_text_block'>
            <h5 className='success_head'>Document uplaoded succesfully!</h5>
            <p className='success_para'>Analysis_file_10_June_2025.xlsx</p>
          </div>
        </div>
        <div className='btn_right_block'>
        <Button variant="primary" className="remove_doc_btn">Remove doc.</Button>
        <Button variant="primary" className="start_mapping_btn">Start Mapping <FeatherIcon.File className='btn_icon'/></Button>
        </div>
      </div>
    </div>
  )
}

export default CreateBenchmarkByTemplateUpload